/**
 * Workspace continuity — one operating sequence inside one readable desk.
 */

'use client'

import React from 'react'
import Link from 'next/link'

const WORKFLOW = [
  {
    verb: 'Observe',
    title: 'Market and exposure',
    body: 'Review the market alongside your positions and working orders. See where you already have exposure.',
  },
  {
    verb: 'Understand',
    title: 'Agent intent',
    body: 'Read what your agent is considering and the reason behind it. Paper activity remains clearly labeled.',
  },
  {
    verb: 'Supervise',
    title: 'Continue, pause, or stop',
    body: 'Keep the decision yours. Continue, pause, or stop the agent with market and portfolio context still in view.',
  },
] as const

export const DeskSurfacesSection: React.FC = () => {
  return (
    <section
      id="surfaces"
      className="lp-section lp-section-surfaces"
      aria-labelledby="surfaces-title"
    >
      <div className="lp-band lp-band-surfaces">
        <header className="lp-band-head">
          <div className="lp-band-head-copy">
            <p className="lp-kicker">One continuous workflow</p>
            <h2 id="surfaces-title" className="lp-section-title">
              Observe. Understand. Supervise.
            </h2>
            <p className="lp-section-lede">
              Move from market context to agent decisions and controls in a single workflow.
              Start on paper to learn how the desk works before choosing live tools.
            </p>
          </div>
        </header>

        <ol className="lp-workflow-rail" aria-label="Mechagora supervision workflow">
          {WORKFLOW.map((step) => (
            <li key={step.verb}>
              <span className="lp-workflow-verb">{step.verb}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>

        <p className="lp-workflow-boundary">
          Free Desk is PAPER only. Operator adds manual live trading and full agent chat.
          Desk adds grid/DCA and the first live agent. Pro adds five live agents, advanced
          analytics, and API access.{' '}
          <Link href="/pricing" className="lp-inline-link">Compare plans</Link>.
        </p>
      </div>
    </section>
  )
}
